import {TokenService} from '../TokenService';

import {useDialogCrup} from '../../../../shared/hooks/DialogCrup';
import {useTranslation} from '../../../../shared/language';

export const CreateICA = ({header, dataKey, refreshLazyData}) => {
  const {t} = useTranslation();

  const {render, create} = useDialogCrup({
    header,
    dataKey,
    width: '45rem',
    fields: [
      {type: 'custom', className: 'md:col-12 text-center mb-3', body: (<img src="/images/I-CA-logo.jpeg" alt=""/>)},
      {type: 'custom', className: 'md:col-12 text-center mb-0', body: <h4 className="mb-1">{t('common.signingServerSetup')}</h4>},
      {type: 'custom', className: 'md:col-12 text-center mb-5', body: <i>{t('common.certificateConnectionInfo')}</i>},
      {field: 'authCode', header: t('common.applicationId'), required: true, InputTextProps: {maxLength: 50}, className: 'md:col-12'},
      {field: 'passwordCer', header: t('common.certificatePassword'), type: 'Password', required: true, className: 'md:col-12'}
    ],
    createItem: (item) => {
      item.tokenType = 4;
      return TokenService.create(item);
    },
    refreshLazyData
  });

  return {render, open: create};

}
